import { HttpClient } from '@angular/common/http';
import { serviceUrl } from './common/serviceconstants';
import { GenericHttpClient } from './Services/Basicauthentication';
import { Injectable } from '@angular/core';

@Injectable()

export class UtilityServices {
    GetPhoneArea(phone: string): string {
        if (phone === null || phone === '') {
            return '';
        } else if (phone.length >= 3) {
            return phone.substring(0, 3);
        } else {
            return phone;
        }
    }

    GetPhoneNumber(phone: string): string {
        if (phone === null || phone === '') {
            return '';
        } else if (phone.length >= 10) {
            const part1 = phone.substring(3, 6);
            const part2 = phone.substring(6, 10);
            return part1 + '-' + part2;
        } else {
            return phone;
        }
    }

    GetFormatedPhoneNumber(phone: string): string {
        if (phone === null || phone === '') {
            return '';
        } else {
            return this.GetPhoneArea(phone) + ' ' + this.GetPhoneNumber(phone);
        }
    }

    GetFormatedDateString(date): string {
        if (date instanceof Date === true) {
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String (date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return mm + '/' + dd + '/' + year;
        } else {
            return '';
        }
    }

    CheckValidDate = (date: string): boolean => {
        if (isNaN(Date.parse(date)) === true) {
            return false;
        }
        return true;
    }

    // Roles
    // 1 = Admin, 2 = Manager, 3 = Agent, 4 = External User, 5 = Closure Agent, 6 = Executive Assistant, 7 = Senior Agent
    async GetUserAccess(Task: string, ProjectID: any, httpClient: GenericHttpClient): Promise<boolean> {
        const UserID = parseInt(sessionStorage.getItem('UserID'), 10);
        const RoleID = parseInt(sessionStorage.getItem('RoleID'), 10);
        if (RoleID === 1 || RoleID === 2 ) {  // Admin or manager
            return true;
        } else {
            if (Task === 'CommentAdd' && (RoleID === 3 || RoleID === 5)) { // agent or Closure Agent
                return true;
            } else {
                const bRet = await this.GrantAccess(UserID, Task, httpClient);
                if (bRet === true) {
                    if (RoleID === 6) {   // Executive Assistant
                        return true;
                    } else {
                        const bAssigned = await this.ProjectAssigned(UserID, ProjectID, httpClient);
                        if (bAssigned === true) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
             }
        }
    }

    GrantAccess(UserID: number, FunctItem: string, httpClient: GenericHttpClient): Promise<boolean> {
        const ret = httpClient.get(serviceUrl + '/api/DropList/GrantAccess',
            { UserID, FunctItem }).toPromise<any>().then(response => {
                const bRet = response.Data;
                return bRet;
            });
        return ret;
    }

    ProjectAssigned(UserID: number, ProjectID: number, httpClient: GenericHttpClient): Promise<boolean> {
        return httpClient.get(serviceUrl + '/api/DropList/ProjectAssigned',
        { UserID, ProjectID }).toPromise<any>().then(response => {
            const bRet = response.Data;
            return bRet;
        });
    }

    ShowMap(ReNo: string): void {
        const reNum = ReNo.replace(',', '');
        const url = 'http://maps.coj.net/duvalproperty/?RE=' + reNum;
        window.open(url, '_blank');
    }
}
